import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { ADD_TO_MY_TEMPLATE, SET_TIP_FLAG, TEMPLATE_DETAIL, } from './cgi-path';
// 只有是第三方模板才会发请求，所以可以先固定是 3
var TEMPLATE_TYPE = 3;
// setTipFlag 入参type,   这里还没搞清楚为什么是写死个37,  待和后台确认
var SET_TIP_FLAG_TYPE = 37;
// setTipFlag 入参flag,   这里还没搞清楚为什么是写死个1,  待和后台确认
var SET_TIP_FLAG_FLAG = 1;
var TemplateRepository = /** @class */ (function () {
    function TemplateRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    TemplateRepository.prototype.addToMyTemplate = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_TO_MY_TEMPLATE, formData)];
            });
        });
    };
    TemplateRepository.prototype.templateDetail = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { template_type: TEMPLATE_TYPE, xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(TEMPLATE_DETAIL, formData)];
            });
        });
    };
    TemplateRepository.prototype.setTipFlag = function (globalPadId) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    globalPadId: globalPadId,
                    type: SET_TIP_FLAG_TYPE,
                    flag: SET_TIP_FLAG_FLAG,
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(SET_TIP_FLAG, formData)];
            });
        });
    };
    TemplateRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], TemplateRepository);
    return TemplateRepository;
}());
export { TemplateRepository };
